"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailsService = void 0;
class EmailsService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Get all emails
     * @param payload
     * @param page
     * @param count
     * @returns EmailsResponse
     * @throws ApiError
     */
    getEmails(payload, page, count) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/email',
            query: {
                'payload': payload,
                'page': page,
                'count': count,
            },
        });
    }
    /**
     * Get email by id
     * @param id
     * @returns EmailResponse
     * @throws ApiError
     */
    getEmail(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/email/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Send digest emails
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    sendDigestEmails(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/email/digest',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Send manual digest emails
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    sendManualDigestEmails(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/email/manual-digest',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Send special offer emails using a scheduled job
     * @param daysGap
     * @returns any Successful response
     * @throws ApiError
     */
    sendSpecialOfferEmails(daysGap) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/email/special/{daysGap}',
            path: {
                'daysGap': daysGap,
            },
        });
    }
    /**
     * Send manual special offer emails
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    sendManualSpecialOfferEmails(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/email/manual-special',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get email logs
     * @param page
     * @param count
     * @returns EmailLogsResponse
     * @throws ApiError
     */
    getEmailLogs(page, count) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/email-logs',
            query: {
                'page': page,
                'count': count,
            },
        });
    }
    /**
     * Get advertiser segmentation
     * @param id
     * @returns EmailAdvertiserSegmentationResponse
     * @throws ApiError
     */
    getAdvertisersSegmentation(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/email-logs/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Get failure reasons segmentation
     * @param id
     * @returns EmailFailuresSegmentationResponse
     * @throws ApiError
     */
    getFailuresSegmentation(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/email-logs/{id}/failures',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Download failure reasons segmentation as csv.
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    downloadFailuresSegmentation(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/email-logs/{id}/failures-download',
            path: {
                'id': id,
            },
        });
    }
    /**
     * End point to test the outcome of an email without actually sending to a creator
     * @param id
     * @param type
     * @returns SponsorshipsTestResponse
     * @throws ApiError
     */
    testEmailSponsorships(id, type) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/email-test/{id}',
            path: {
                'id': id,
            },
            query: {
                'type': type,
            },
        });
    }
    /**
     * Get stats on sent emails
     * @param from
     * @param to
     * @param type
     * @returns SentEmailsStatsResponse
     * @throws ApiError
     */
    getSentEmailsStats(from, to, type) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/email-stats',
            query: {
                'from': from,
                'to': to,
                'type': type,
            },
        });
    }
    /**
     * Download creators with bounce event as csv.
     * @param from
     * @param to
     * @param type
     * @returns any Successful response
     * @throws ApiError
     */
    downloadCreatorsWithBounceEvent(from, to, type) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/email-stats/bounce',
            query: {
                'from': from,
                'to': to,
                'type': type,
            },
        });
    }
    /**
     * Download creators without open event as csv.
     * @param from
     * @param to
     * @param type
     * @returns any Successful response
     * @throws ApiError
     */
    downloadCreatorsWithoutOpenEvent(from, to, type) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/email-stats/not-opened',
            query: {
                'from': from,
                'to': to,
                'type': type,
            },
        });
    }
}
exports.EmailsService = EmailsService;
